function normalizeCount(count) {
  return Math.max(0, Number.parseInt(count, 10) || 0)
}

export async function syncAppBadge(count) {
  const unreadCount = normalizeCount(count)

  try {
    if (unreadCount > 0 && 'setAppBadge' in navigator) {
      await navigator.setAppBadge(unreadCount)
    } else if (unreadCount === 0 && 'clearAppBadge' in navigator) {
      await navigator.clearAppBadge()
    }
  } catch (error) {
    console.warn('Impossible de mettre a jour le badge de l application.', error)
  }
}

export async function clearAppBadgeAndNotifications() {
  await syncAppBadge(0)

  if (!('serviceWorker' in navigator)) return

  try {
    const registration = await navigator.serviceWorker.ready
    const notifications = await registration.getNotifications()
    notifications.forEach((notification) => notification.close())
  } catch (error) {
    console.warn('Impossible de fermer les notifications systeme.', error)
  }
}
